import useSWRImmutable from 'swr/immutable';

import type { INotificationCenterSubscription } from '@/api/notificationCenter';
import { fetcherSS } from '@/modules/api';

export const useNotificationCenterSubscription = () =>
  useSWRImmutable<INotificationCenterSubscription>(
    '/notification_center/centrifugo/subscription',
    fetcherSS
  );
